/* GENERATED FILE — do not edit.
   Source: shared-ui/ui/Bar.js
   Run "node shared-ui/sync.js" after editing the source. */
import React from 'react';

/**
 * One horizontal bar row.
 *   label   – row name on the left
 *   value   – numeric magnitude used for the width
 *   display – what is printed on the right (falls back to value)
 *   max     – the value that fills the track (falls back to value)
 *
 * One colour only (--mark). Bars are NEVER coloured by rank or index.
 */
export default function Bar({ label, value, display, max, delay = 0 }) {
  const num = Number(value);
  const top = Number(max);
  const safeNum = Number.isFinite(num) ? num : 0;
  const safeMax = Number.isFinite(top) && top > 0 ? top : safeNum;

  let pct = safeMax > 0 ? (safeNum / safeMax) * 100 : 0;
  if (!Number.isFinite(pct) || pct < 0) pct = 0;
  if (pct > 100) pct = 100;

  const shown = display !== undefined && display !== null ? display : safeNum;

  return (
    <div className="bar-row">
      <div className="bar-name">{label}</div>
      <div className="bar-track">
        <div
          className="bar-fill"
          style={{ width: pct + '%', animationDelay: delay ? delay + 's' : undefined }}
        />
      </div>
      <div className="bar-value num">{shown}</div>
    </div>
  );
}
